import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import DotMenu, { Options } from '../primitives/dotMenu/DotMenu';
import { MenuConstants } from '../../constants/MenuConstants';
import ActionDropdown from '../primitives/dropdowns/ActionDropdown';
import { checkForPermission } from '../../util/permissionUtils';
import { AppConstants } from '../../constants/AppConstants';

interface CareplanMenuProps {
  className?: string;
  iconSize?: string;
  dropdownMenu?: boolean;
  onOptionClick?: Function;
  disabled?: boolean;
}

const CareplanMenu: React.FC<CareplanMenuProps> = ({
  iconSize = '',
  className = '',
  dropdownMenu = false,
  onOptionClick,
  disabled = false
}) => {
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState<Options | null>();
  const { t } = useTranslation();

  useEffect(() => {
    if (selectedOption) {
      switch (selectedOption.key) {
        case MenuConstants.MENU_CARE_PLAN_ACTIVITIES:
          if (onOptionClick) {
            onOptionClick(MenuConstants.MENU_CARE_PLAN_ACTIVITIES);
          }
          break;
        case MenuConstants.MENU_CARE_PLAN_ACTIVITIES_CREATE:
          if (onOptionClick) {
            onOptionClick(MenuConstants.MENU_CARE_PLAN_ACTIVITIES_CREATE);
          }
          break;
        case MenuConstants.MENU_CARE_PLAN_NOTES:
          if (onOptionClick) {
            onOptionClick(MenuConstants.MENU_CARE_PLAN_NOTES);
          }
          break;
        case MenuConstants.MENU_CARE_PLAN_NOTES_CREATE:
          if (onOptionClick) {
            onOptionClick(MenuConstants.MENU_CARE_PLAN_NOTES_CREATE);
          }
          break;
        case MenuConstants.MENU_CARE_PLAN_EDIT_DETAILS:
          if (onOptionClick) {
            onOptionClick(MenuConstants.MENU_CARE_PLAN_EDIT_DETAILS);
          }
          break;
      }
    }
  }, [selectedOption]);

  const getMenuOptions = () => {
    let options: any = [];

    if (dropdownMenu) {
      if (checkForPermission([AppConstants.PERMISSION_CAREPLAN_TEMPLATE_PATCH])) {
        options.push({
          display: `${t('T_CARE_PLAN_EDIT')}`,
          key: MenuConstants.MENU_CARE_PLAN_EDIT_DETAILS
        });
      }
    }

    if (checkForPermission([AppConstants.PERMISSION_CAREPLAN_ACTIVITY_LIST])) {
      options.push({
        display: `${t('T_VIEW_CARE_PLAN_ACTIVITIES')}`,
        key: MenuConstants.MENU_CARE_PLAN_ACTIVITIES
      });
    }
    if (checkForPermission([AppConstants.PERMISSION_CAREPLAN_TEMPLATE_ACTIVITY_CREATE])) {
      options.push({
        display: `${t('T_ADD_AN_ACTIVITY')}`,
        key: MenuConstants.MENU_CARE_PLAN_ACTIVITIES_CREATE
      });
    }

    if (checkForPermission([AppConstants.PERMISSION_CAREPLAN_TEMPLATE_NOTES_LIST])) {
      options.push({
        display: `${t('T_CARE_PLAN_VIEW_NOTE')}`,
        key: MenuConstants.MENU_CARE_PLAN_NOTES
      });
    }

    if (checkForPermission([AppConstants.PERMISSION_CAREPLAN_TEMPLATE_NOTES_CREATE])) {
      options.push({
        display: `${t('T_CARE_PLAN_ADD_A_NOTE')}`,
        key: MenuConstants.MENU_CARE_PLAN_NOTES_CREATE
      });
    }

    return options;
  };

  return (
    <>
      {dropdownMenu ? (
        <ActionDropdown
          className={disabled ? 'disabled' : ''}
          options={getMenuOptions()}
          onSelectedOptionChange={(value: any) => {
            setSelectedOption(value);
          }}
          value={selectedOption}
          defaultLabel={t('T_CARE_PLAN_MANAGE')}
        />
      ) : (
        <DotMenu
          options={getMenuOptions()}
          onSelectedOptionChange={(value) => {
            setSelectedOption(value);
          }}
          containerClassName={className}
          dropDownStyle={{ left: '-155px', top: '35px' }}
          value={selectedOption}
        />
      )}
    </>
  );
};

export default CareplanMenu;
